import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "lini-view-container" }
const _hoisted_2 = {
  key: 0,
  class: "doc-header-card"
}
const _hoisted_3 = { class: "doc-header-top" }
const _hoisted_4 = { class: "doc-header-main" }
const _hoisted_5 = { class: "doc-hdr-numar" }
const _hoisted_6 = { class: "doc-hdr-categorie-badge" }
const _hoisted_7 = { class: "doc-header-actions" }
const _hoisted_8 = { class: "doc-meta-strip" }
const _hoisted_9 = { class: "doc-meta-item doc-meta-item--partener" }
const _hoisted_10 = { class: "doc-meta-content" }
const _hoisted_11 = ["title"]
const _hoisted_12 = { class: "doc-meta-item" }
const _hoisted_13 = { class: "doc-meta-content" }
const _hoisted_14 = { class: "doc-meta-value" }
const _hoisted_15 = { class: "doc-meta-item" }
const _hoisted_16 = { class: "doc-meta-content" }
const _hoisted_17 = { class: "doc-meta-value" }
const _hoisted_18 = { class: "doc-meta-item" }
const _hoisted_19 = { class: "doc-meta-content" }
const _hoisted_20 = { class: "doc-meta-value" }
const _hoisted_21 = { class: "doc-meta-item" }
const _hoisted_22 = { class: "doc-meta-content" }
const _hoisted_23 = { class: "doc-meta-label" }
const _hoisted_24 = { class: "doc-meta-value" }
const _hoisted_25 = {
  key: 2,
  class: "doc-totals-box"
}
const _hoisted_26 = {
  key: 0,
  class: "doc-totals-row"
}
const _hoisted_27 = { class: "doc-totals-value-secondary" }
const _hoisted_28 = {
  key: 1,
  class: "doc-totals-separator"
}
const _hoisted_29 = {
  key: 2,
  class: "doc-totals-row"
}
const _hoisted_30 = { class: "doc-totals-value-main" }
const _hoisted_31 = {
  key: 1,
  class: "grid-section"
}
const _hoisted_32 = {
  key: 1,
  class: "no-lines-empty-state"
}
const _hoisted_33 = {
  key: 2,
  class: "null-document-state"
}
const _hoisted_34 = { style: {"display":"flex","flex-direction":"column","height":"100%","overflow":"hidden"} }
const _hoisted_35 = { style: {"flex-shrink":"0","height":"60px","padding":"16px 24px","border-radius":"4px 4px 0 0","background":"linear-gradient(90deg,#ff2c21,#ff6a4a)","display":"flex","align-items":"center","justify-content":"space-between"} }
const _hoisted_36 = { style: {"display":"flex","align-items":"center","gap":"16px"} }
const _hoisted_37 = { style: {"display":"flex","flex-direction":"column","color":"white"} }
const _hoisted_38 = { style: {"font-size":"16px","font-weight":"700"} }
const _hoisted_39 = { style: {"flex":"1","overflow":"hidden"} }
const _hoisted_40 = {
  key: 0,
  class: "add-form-grid"
}
const _hoisted_41 = {
  class: "add-form-field",
  style: {"overflow":"hidden"}
}
const _hoisted_42 = { class: "add-form-field" }
const _hoisted_43 = { class: "add-form-field" }
const _hoisted_44 = { class: "add-form-field" }
const _hoisted_45 = { class: "add-form-field" }
const _hoisted_46 = { class: "add-form-field" }
const _hoisted_47 = { class: "add-form-field" }
const _hoisted_48 = { class: "add-form-field" }
const _hoisted_49 = { class: "add-form-field add-form-field--full" }
const _hoisted_50 = {
  key: 1,
  class: "add-form-grid"
}
const _hoisted_51 = {
  class: "add-form-field",
  style: {"overflow":"hidden"}
}
const _hoisted_52 = { class: "add-form-field" }
const _hoisted_53 = { class: "add-form-field" }
const _hoisted_54 = { class: "add-form-field" }
const _hoisted_55 = { class: "add-form-field" }
const _hoisted_56 = { class: "add-form-field" }
const _hoisted_57 = { class: "add-form-field" }
const _hoisted_58 = { class: "add-form-field add-form-field--full" }
const _hoisted_59 = { class: "add-form-field add-form-field--full" }
const _hoisted_60 = { class: "add-form-field add-form-field--full" }
const _hoisted_61 = {
  key: 2,
  class: "add-form-grid",
  style: {"overflow-y":"auto","max-height":"100%"}
}
const _hoisted_62 = {
  class: "add-form-field",
  style: {"overflow":"hidden"}
}
const _hoisted_63 = { class: "add-form-field" }
const _hoisted_64 = { class: "add-form-field" }
const _hoisted_65 = { class: "add-form-field" }
const _hoisted_66 = { class: "add-form-field" }
const _hoisted_67 = { class: "add-form-field" }
const _hoisted_68 = { class: "add-form-field" }
const _hoisted_69 = { class: "add-form-field" }
const _hoisted_70 = { class: "add-form-field" }
const _hoisted_71 = { class: "add-form-field" }
const _hoisted_72 = { class: "add-form-field add-form-field--full" }
const _hoisted_73 = { class: "add-form-field add-form-field--full" }
const _hoisted_74 = { class: "add-form-field add-form-field--full" }
const _hoisted_75 = { class: "add-form-field add-form-field--full" }
const _hoisted_76 = {
  key: 3,
  class: "add-form-grid"
}
const _hoisted_77 = {
  class: "add-form-field",
  style: {"overflow":"hidden"}
}
const _hoisted_78 = { class: "add-form-field" }
const _hoisted_79 = { class: "add-form-field" }
const _hoisted_80 = { class: "add-form-field" }
const _hoisted_81 = { class: "add-form-field" }
const _hoisted_82 = { class: "add-form-field" }
const _hoisted_83 = { class: "add-form-field add-form-field--full" }
const _hoisted_84 = {
  key: 4,
  class: "add-form-grid",
  style: {"overflow-y":"auto","max-height":"100%"}
}
const _hoisted_85 = {
  class: "add-form-field",
  style: {"overflow":"hidden"}
}
const _hoisted_86 = { class: "add-form-field" }
const _hoisted_87 = {
  class: "add-form-field",
  style: {"overflow":"hidden"}
}
const _hoisted_88 = { class: "add-form-field" }
const _hoisted_89 = { class: "add-form-field" }
const _hoisted_90 = { class: "add-form-field" }
const _hoisted_91 = {
  class: "add-form-field",
  style: {"overflow":"hidden"}
}
const _hoisted_92 = {
  class: "add-form-field",
  style: {"overflow":"hidden"}
}
const _hoisted_93 = { class: "add-form-field" }
const _hoisted_94 = { class: "add-form-field" }
const _hoisted_95 = { class: "add-form-field" }
const _hoisted_96 = { class: "add-form-field" }
const _hoisted_97 = { class: "add-form-field add-form-field--full" }
const _hoisted_98 = {
  key: 5,
  class: "add-form-grid",
  style: {"overflow-y":"auto","max-height":"100%"}
}
const _hoisted_99 = {
  class: "add-form-field add-form-field--full",
  style: {"overflow":"hidden"}
}
const _hoisted_100 = { class: "add-form-field" }
const _hoisted_101 = {
  class: "add-form-field",
  style: {"overflow":"hidden"}
}
const _hoisted_102 = { class: "add-form-field" }
const _hoisted_103 = { class: "add-form-field" }
const _hoisted_104 = { class: "add-form-field" }
const _hoisted_105 = { class: "add-form-field" }
const _hoisted_106 = {
  class: "add-form-field",
  style: {"overflow":"hidden"}
}
const _hoisted_107 = {
  class: "add-form-field",
  style: {"overflow":"hidden"}
}
const _hoisted_108 = { class: "add-form-field add-form-field--full" }
const _hoisted_109 = {
  key: 6,
  class: "add-form-grid",
  style: {"overflow-y":"auto","max-height":"100%"}
}
const _hoisted_110 = {
  class: "add-form-field add-form-field--full",
  style: {"overflow":"hidden"}
}
const _hoisted_111 = { class: "add-form-field" }
const _hoisted_112 = {
  class: "add-form-field",
  style: {"overflow":"hidden"}
}
const _hoisted_113 = { class: "add-form-field" }
const _hoisted_114 = { class: "add-form-field" }
const _hoisted_115 = { class: "add-form-field" }
const _hoisted_116 = { class: "add-form-field" }
const _hoisted_117 = { class: "add-form-field" }
const _hoisted_118 = {
  class: "add-form-field",
  style: {"overflow":"hidden"}
}
const _hoisted_119 = {
  class: "add-form-field",
  style: {"overflow":"hidden"}
}
const _hoisted_120 = { class: "add-form-field" }
const _hoisted_121 = { class: "add-form-field" }
const _hoisted_122 = { class: "add-form-field" }
const _hoisted_123 = { class: "add-form-field" }
const _hoisted_124 = { class: "add-form-field" }
const _hoisted_125 = { class: "add-form-field" }
const _hoisted_126 = {
  class: "add-form-field",
  style: {"grid-column":"2"}
}
const _hoisted_127 = { class: "add-form-field add-form-field--full" }
const _hoisted_128 = {
  key: 7,
  class: "add-form-grid",
  style: {"overflow-y":"auto","max-height":"100%"}
}
const _hoisted_129 = {
  class: "add-form-field add-form-field--full",
  style: {"overflow":"hidden"}
}
const _hoisted_130 = { class: "add-form-field" }
const _hoisted_131 = {
  class: "add-form-field",
  style: {"overflow":"hidden"}
}
const _hoisted_132 = { class: "add-form-field" }
const _hoisted_133 = { class: "add-form-field" }
const _hoisted_134 = { class: "add-form-field" }
const _hoisted_135 = { class: "add-form-field" }
const _hoisted_136 = { class: "add-form-field" }
const _hoisted_137 = {
  class: "add-form-field",
  style: {"overflow":"hidden"}
}
const _hoisted_138 = {
  class: "add-form-field",
  style: {"overflow":"hidden"}
}
const _hoisted_139 = { class: "add-form-field" }
const _hoisted_140 = { class: "add-form-field" }
const _hoisted_141 = { class: "add-form-field" }
const _hoisted_142 = { class: "add-form-field" }
const _hoisted_143 = { class: "add-form-field" }
const _hoisted_144 = { class: "add-form-field" }
const _hoisted_145 = {
  class: "add-form-field",
  style: {"grid-column":"2"}
}
const _hoisted_146 = { class: "add-form-field add-form-field--full" }
const _hoisted_147 = {
  class: "form-footer-linie",
  style: {"flex-shrink":"0"}
}
const _hoisted_148 = { class: "footer-right-linie" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DxLoadPanel = _resolveComponent("DxLoadPanel")!
  const _component_DxButton = _resolveComponent("DxButton")!
  const _component_DxDropDownOptions = _resolveComponent("DxDropDownOptions")!
  const _component_DxLookup = _resolveComponent("DxLookup")!
  const _component_DxNumberBox = _resolveComponent("DxNumberBox")!
  const _component_DxTextBox = _resolveComponent("DxTextBox")!
  const _component_DxTreeView = _resolveComponent("DxTreeView")!
  const _component_DxDropDownBox = _resolveComponent("DxDropDownBox")!
  const _component_DxDateBox = _resolveComponent("DxDateBox")!
  const _component_DxPopup = _resolveComponent("DxPopup")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_DxLoadPanel, {
      visible: _ctx.isPrinting,
      message: "Se generează PDF-ul...",
      "show-overlay": true,
      "show-pane": true
    }, null, 8, ["visible"]),
    (_ctx.document)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _cache[96] || (_cache[96] = _createElementVNode("i", { class: "dx-icon dx-icon-doc doc-hdr-icon" }, null, -1)),
              _createElementVNode("span", _hoisted_5, "#" + _toDisplayString(_ctx.document.Numar), 1),
              _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.document.Categorie), 1)
            ]),
            _createElementVNode("div", _hoisted_7, [
              _createVNode(_component_DxButton, {
                icon: "info",
                hint: "Detalii Document",
                "styling-mode": "text",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('toggle-details')))
              }),
              _createVNode(_component_DxButton, {
                icon: "print",
                hint: "Tipărire PDF",
                "styling-mode": "text",
                onClick: _ctx.onTiparirePDF
              }, null, 8, ["onClick"]),
              _createVNode(_component_DxButton, {
                icon: "share",
                hint: "Partajează",
                "styling-mode": "text",
                onClick: _ctx.shareClicked
              }, null, 8, ["onClick"])
            ])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _cache[98] || (_cache[98] = _createElementVNode("i", { class: "dx-icon dx-icon-group doc-meta-icon" }, null, -1)),
              _createElementVNode("div", _hoisted_10, [
                _cache[97] || (_cache[97] = _createElementVNode("span", { class: "doc-meta-label" }, "Partener", -1)),
                _createElementVNode("span", {
                  class: "doc-meta-value doc-meta-value--partener",
                  title: _ctx.document.Partener
                }, _toDisplayString(_ctx.document.Partener || '—'), 9, _hoisted_11)
              ])
            ]),
            _cache[110] || (_cache[110] = _createElementVNode("div", { class: "doc-meta-divider" }, null, -1)),
            _createElementVNode("div", _hoisted_12, [
              _cache[100] || (_cache[100] = _createElementVNode("i", { class: "dx-icon dx-icon-event doc-meta-icon" }, null, -1)),
              _createElementVNode("div", _hoisted_13, [
                _cache[99] || (_cache[99] = _createElementVNode("span", { class: "doc-meta-label" }, "Data", -1)),
                _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.formatDate(_ctx.document.Data)), 1)
              ])
            ]),
            _cache[111] || (_cache[111] = _createElementVNode("div", { class: "doc-meta-divider" }, null, -1)),
            _createElementVNode("div", _hoisted_15, [
              _cache[102] || (_cache[102] = _createElementVNode("i", { class: "dx-icon dx-icon-tags doc-meta-icon" }, null, -1)),
              _createElementVNode("div", _hoisted_16, [
                _cache[101] || (_cache[101] = _createElementVNode("span", { class: "doc-meta-label" }, "Tip", -1)),
                _createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.document.Tip), 1)
              ])
            ]),
            (_ctx.document.Scadenta)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _cache[105] || (_cache[105] = _createElementVNode("div", { class: "doc-meta-divider" }, null, -1)),
                  _createElementVNode("div", _hoisted_18, [
                    _cache[104] || (_cache[104] = _createElementVNode("i", { class: "dx-icon dx-icon-clock doc-meta-icon" }, null, -1)),
                    _createElementVNode("div", _hoisted_19, [
                      _cache[103] || (_cache[103] = _createElementVNode("span", { class: "doc-meta-label" }, "Scadență", -1)),
                      _createElementVNode("span", _hoisted_20, _toDisplayString(_ctx.formatDate(_ctx.document.Scadenta)), 1)
                    ])
                  ])
                ], 64))
              : _createCommentVNode("", true),
            (_ctx.document.Curs && _ctx.document.Valuta && _ctx.document.Valuta !== 'RON')
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _cache[107] || (_cache[107] = _createElementVNode("div", { class: "doc-meta-divider" }, null, -1)),
                  _createElementVNode("div", _hoisted_21, [
                    _cache[106] || (_cache[106] = _createElementVNode("i", { class: "dx-icon dx-icon-money doc-meta-icon" }, null, -1)),
                    _createElementVNode("div", _hoisted_22, [
                      _createElementVNode("span", _hoisted_23, "Curs " + _toDisplayString(_ctx.document.Valuta), 1),
                      _createElementVNode("span", _hoisted_24, _toDisplayString(_ctx.document.Curs?.toLocaleString('ro-RO', { minimumFractionDigits: 4 })), 1)
                    ])
                  ])
                ], 64))
              : _createCommentVNode("", true),
            _cache[112] || (_cache[112] = _createElementVNode("div", { class: "doc-meta-spacer" }, null, -1)),
            (_ctx.document.Total || _ctx.document.Valoare)
              ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                  (_ctx.document.Valoare)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                        _cache[108] || (_cache[108] = _createElementVNode("span", { class: "doc-totals-label" }, "Fără TVA", -1)),
                        _createElementVNode("span", _hoisted_27, _toDisplayString(_ctx.document.Valoare.toLocaleString('ro-RO', { minimumFractionDigits: 2 })) + " " + _toDisplayString(_ctx.document.Valuta || 'RON'), 1)
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.document.Valoare && _ctx.document.Total)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_28))
                    : _createCommentVNode("", true),
                  (_ctx.document.Total)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                        _cache[109] || (_cache[109] = _createElementVNode("span", { class: "doc-totals-label doc-totals-label--main" }, [
                          _createElementVNode("i", {
                            class: "dx-icon dx-icon-money",
                            style: {"font-size":"11px","vertical-align":"middle","margin-right":"3px"}
                          }),
                          _createTextVNode(" Total ")
                        ], -1)),
                        _createElementVNode("span", _hoisted_30, _toDisplayString(_ctx.document.Total.toLocaleString('ro-RO', { minimumFractionDigits: 2 })) + " " + _toDisplayString(_ctx.document.Valuta || 'RON'), 1)
                      ]))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true)
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.document)
      ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
          (_ctx.liniiComponent && _ctx.areLinii)
            ? (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.liniiComponent), {
                key: 0,
                ref: "liniiComponent",
                document: _ctx.document,
                onOpenAddModal: _ctx.onAddClick,
                onRefreshDocument: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('refresh-document', $event))),
                onHasLiniiChanged: _ctx.onHasLiniiChanged
              }, null, 40, ["document", "onOpenAddModal", "onHasLiniiChanged"]))
            : _createCommentVNode("", true),
          (!_ctx.areLinii)
            ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                _cache[113] || (_cache[113] = _createElementVNode("i", { class: "dx-icon-info" }, null, -1)),
                _cache[114] || (_cache[114] = _createElementVNode("p", null, "Acest document nu are linii adăugate.", -1)),
                _createVNode(_component_DxButton, {
                  icon: "add",
                  text: "Adaugă prima linie",
                  type: "success",
                  "styling-mode": "contained",
                  onClick: _ctx.onAddClick
                }, null, 8, ["onClick"])
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    (_ctx.document === null)
      ? (_openBlock(), _createElementBlock("div", _hoisted_33, [...(_cache[115] || (_cache[115] = [
          _createElementVNode("i", { class: "dx-icon-warning" }, null, -1),
          _createElementVNode("p", null, "Vă rugăm să selectați un document pentru a vedea detaliile.", -1)
        ]))]))
      : _createCommentVNode("", true),
    _createVNode(_component_DxPopup, {
      visible: _ctx.isModalAddVisible,
      "onUpdate:visible": _cache[94] || (_cache[94] = ($event: any) => ((_ctx.isModalAddVisible) = $event)),
      "show-title": false,
      width: _ctx.addPopupWidth,
      height: _ctx.addPopupHeight,
      "close-on-outside-click": false,
      "wrapper-attr": { class: 'popup-linii' },
      onHiding: _ctx.onPopupHiding
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_34, [
          _createElementVNode("div", _hoisted_35, [
            _createElementVNode("div", _hoisted_36, [
              _cache[117] || (_cache[117] = _createElementVNode("span", {
                class: "dx-icon-add",
                style: {"font-size":"24px","color":"white"}
              }, null, -1)),
              _createElementVNode("div", _hoisted_37, [
                _createElementVNode("span", _hoisted_38, "Adăugare linie — " + _toDisplayString(_ctx.document?.Categorie), 1),
                _cache[116] || (_cache[116] = _createElementVNode("span", { style: {"font-size":"12px","opacity":"0.9"} }, "Completează detaliile liniei noi", -1))
              ])
            ]),
            _cache[118] || (_cache[118] = _createElementVNode("span", { style: {"background":"rgba(255,255,255,0.2)","color":"white","padding":"4px 12px","border-radius":"12px","font-size":"12px","font-weight":"600"} }, "Nou", -1))
          ]),
          _createElementVNode("div", _hoisted_39, [
            (_ctx.document?.Categorie === 'Contabilitate')
              ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
                  _createElementVNode("div", _hoisted_41, [
                    _createVNode(_component_DxLookup, {
                      label: "Produs",
                      "label-mode": "floating",
                      "data-source": _ctx.dsProdus,
                      "value-expr": "Id",
                      "display-expr": _ctx.produsDisplayExpr,
                      "search-expr": ['Cod', 'CodIntern', 'Nume'],
                      "show-clear-button": true,
                      "search-enabled": true,
                      value: _ctx.linieNoua.ProdusId,
                      onValueChanged: _ctx.onValueChangedProdus,
                      "drop-down-options": { width: 'auto' }
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_DxDropDownOptions, { "show-title": false })
                      ]),
                      _: 1
                    }, 8, ["data-source", "display-expr", "value", "onValueChanged"])
                  ]),
                  _createElementVNode("div", _hoisted_42, [
                    _createVNode(_component_DxNumberBox, {
                      label: "Cantitate",
                      "label-mode": "floating",
                      value: _ctx.linieNoua.Cantitate,
                      min: 0,
                      "show-spin-buttons": true,
                      "show-clear-button": true,
                      onValueChanged: _cache[2] || (_cache[2] = (e) => { _ctx.linieNoua.Cantitate = e.value; _ctx.calculateTotalsLinie(); })
                    }, null, 8, ["value"])
                  ]),
                  _createElementVNode("div", _hoisted_43, [
                    _createVNode(_component_DxLookup, {
                      label: "Unitate",
                      "label-mode": "floating",
                      "data-source": _ctx.dsUnitate,
                      "value-expr": "Id",
                      "display-expr": "Simbol",
                      "show-clear-button": true,
                      "search-enabled": true,
                      value: _ctx.linieNoua.UnitateId,
                      "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.linieNoua.UnitateId) = $event))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_DxDropDownOptions, { "show-title": false })
                      ]),
                      _: 1
                    }, 8, ["data-source", "value"])
                  ]),
                  _createElementVNode("div", _hoisted_44, [
                    _createVNode(_component_DxNumberBox, {
                      label: "Procent TVA",
                      "label-mode": "floating",
                      value: _ctx.linieNoua.Tva,
                      "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.linieNoua.Tva) = $event)),
                      min: 0,
                      step: 1,
                      "show-spin-buttons": true,
                      "show-clear-button": true,
                      format: "## '%'",
                      onValueChanged: _cache[5] || (_cache[5] = (e) => { _ctx.linieNoua.Tva = e.value; _ctx.calculateTotalsLinie(); })
                    }, null, 8, ["value"])
                  ]),
                  _createElementVNode("div", _hoisted_45, [
                    _createVNode(_component_DxNumberBox, {
                      label: "Pret Unitar",
                      "label-mode": "floating",
                      value: _ctx.linieNoua.PretUnitar,
                      min: 0,
                      "show-spin-buttons": true,
                      "show-clear-button": true,
                      format: { type: 'fixedPoint', precision: 4 },
                      onValueChanged: _cache[6] || (_cache[6] = (e) => { _ctx.linieNoua.PretUnitar = e.value; _ctx.calculateTotalsLinie(); })
                    }, null, 8, ["value"])
                  ]),
                  _createElementVNode("div", _hoisted_46, [
                    _createVNode(_component_DxLookup, {
                      label: "Categorie Contabilă",
                      "label-mode": "floating",
                      "data-source": _ctx.dsCategorieContabila,
                      "value-expr": "Id",
                      "display-expr": "Nume",
                      "show-clear-button": true,
                      "search-enabled": true,
                      value: _ctx.linieNoua.CategorieContabilaId,
                      onValueChanged: _cache[7] || (_cache[7] = (e) => _ctx.linieNoua.CategorieContabilaId = e.value),
                      "drop-down-options": { width: 'auto' }
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_DxDropDownOptions, { "show-title": false })
                      ]),
                      _: 1
                    }, 8, ["data-source", "value"])
                  ]),
                  _createElementVNode("div", _hoisted_47, [
                    _createVNode(_component_DxLookup, {
                      label: "Cont Debit",
                      "label-mode": "floating",
                      "data-source": _ctx.dsConturi,
                      "value-expr": "Id",
                      "display-expr": _ctx.contDisplayExpr,
                      "search-expr": ['Simbol', 'Nume'],
                      "show-clear-button": true,
                      "search-enabled": true,
                      value: _ctx.linieNoua.DebitId,
                      "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.linieNoua.DebitId) = $event))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_DxDropDownOptions, { "show-title": false })
                      ]),
                      _: 1
                    }, 8, ["data-source", "display-expr", "value"])
                  ]),
                  _createElementVNode("div", _hoisted_48, [
                    _createVNode(_component_DxLookup, {
                      label: "Cont Credit",
                      "label-mode": "floating",
                      "data-source": _ctx.dsConturi,
                      "value-expr": "Id",
                      "display-expr": _ctx.contDisplayExpr,
                      "search-expr": ['Simbol', 'Nume'],
                      "show-clear-button": true,
                      "search-enabled": true,
                      value: _ctx.linieNoua.CreditId,
                      "onUpdate:value": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.linieNoua.CreditId) = $event))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_DxDropDownOptions, { "show-title": false })
                      ]),
                      _: 1
                    }, 8, ["data-source", "display-expr", "value"])
                  ]),
                  _createElementVNode("div", _hoisted_49, [
                    _createVNode(_component_DxTextBox, {
                      label: "Denumire Alternativă",
                      "label-mode": "floating",
                      value: _ctx.linieNoua.Nume,
                      onValueChanged: _cache[10] || (_cache[10] = (e) => _ctx.linieNoua.Nume = e.value)
                    }, null, 8, ["value"])
                  ])
                ]))
              : (_ctx.document?.Categorie === 'Facturi furnizor')
                ? (_openBlock(), _createElementBlock("div", _hoisted_50, [
                    _createElementVNode("div", _hoisted_51, [
                      _createVNode(_component_DxLookup, {
                        label: "Produs",
                        "label-mode": "floating",
                        "data-source": _ctx.dsProdus,
                        "value-expr": "Id",
                        "display-expr": _ctx.produsDisplayExpr,
                        "search-expr": ['Cod', 'CodIntern', 'Nume'],
                        "show-clear-button": true,
                        "search-enabled": true,
                        value: _ctx.linieNoua.ProdusId,
                        onValueChanged: _ctx.onValueChangedProdus,
                        "drop-down-options": { width: 'auto' }
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_DxDropDownOptions, { "show-title": false })
                        ]),
                        _: 1
                      }, 8, ["data-source", "display-expr", "value", "onValueChanged"])
                    ]),
                    _createElementVNode("div", _hoisted_52, [
                      _createVNode(_component_DxNumberBox, {
                        label: "Cantitate",
                        "label-mode": "floating",
                        value: _ctx.linieNoua.Cantitate,
                        min: 0,
                        "show-spin-buttons": true,
                        "show-clear-button": true,
                        onValueChanged: _cache[11] || (_cache[11] = (e) => { _ctx.linieNoua.Cantitate = e.value; _ctx.calculateTotalsLinie(); })
                      }, null, 8, ["value"])
                    ]),
                    _createElementVNode("div", _hoisted_53, [
                      _createVNode(_component_DxLookup, {
                        label: "Unitate",
                        "label-mode": "floating",
                        "data-source": _ctx.dsUnitate,
                        "value-expr": "Id",
                        "display-expr": "Simbol",
                        "show-clear-button": true,
                        "search-enabled": true,
                        value: _ctx.linieNoua.UnitateId,
                        "onUpdate:value": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.linieNoua.UnitateId) = $event))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_DxDropDownOptions, { "show-title": false })
                        ]),
                        _: 1
                      }, 8, ["data-source", "value"])
                    ]),
                    _createElementVNode("div", _hoisted_54, [
                      _createVNode(_component_DxNumberBox, {
                        label: "TVA Inclus %",
                        "label-mode": "floating",
                        value: _ctx.linieNoua.Tva,
                        "onUpdate:value": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.linieNoua.Tva) = $event)),
                        min: 0,
                        step: 1,
                        "show-spin-buttons": true,
                        "show-clear-button": true,
                        format: "## '%'",
                        onValueChanged: _cache[14] || (_cache[14] = (e) => { _ctx.linieNoua.Tva = e.value; _ctx.calculateTotalsLinie(); })
                      }, null, 8, ["value"])
                    ]),
                    _createElementVNode("div", _hoisted_55, [
                      _createVNode(_component_DxNumberBox, {
                        label: "Pret Unitar",
                        "label-mode": "floating",
                        value: _ctx.linieNoua.PretUnitar,
                        min: 0,
                        "show-spin-buttons": true,
                        "show-clear-button": true,
                        format: { type: 'fixedPoint', precision: 4 },
                        onValueChanged: _cache[15] || (_cache[15] = (e) => { _ctx.linieNoua.PretUnitar = e.value; _ctx.calculateTotalsLinie(); })
                      }, null, 8, ["value"])
                    ]),
                    _createElementVNode("div", _hoisted_56, [
                      _createVNode(_component_DxLookup, {
                        label: "Categorie Contabilă",
                        "label-mode": "floating",
                        "data-source": _ctx.dsCategorieContabila,
                        "value-expr": "Id",
                        "display-expr": "Nume",
                        "show-clear-button": true,
                        "search-enabled": true,
                        value: _ctx.linieNoua.CategorieContabilaId,
                        onValueChanged: _cache[16] || (_cache[16] = (e) => _ctx.linieNoua.CategorieContabilaId = e.value),
                        "drop-down-options": { width: 'auto' }
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_DxDropDownOptions, { "show-title": false })
                        ]),
                        _: 1
                      }, 8, ["data-source", "value"])
                    ]),
                    _createElementVNode("div", _hoisted_57, [
                      _createVNode(_component_DxTextBox, {
                        label: "Categorie TVA",
                        "label-mode": "floating",
                        value: _ctx.linieNoua.CategTva,
                        onValueChanged: _cache[17] || (_cache[17] = (e) => _ctx.linieNoua.CategTva = e.value)
                      }, null, 8, ["value"])
                    ]),
                    _createElementVNode("div", _hoisted_58, [
                      _createVNode(_component_DxTextBox, {
                        label: "Cod TVA (SAF-T)",
                        "label-mode": "floating",
                        value: _ctx.linieNoua.SaftTaxCode,
                        onValueChanged: _cache[18] || (_cache[18] = (e) => _ctx.linieNoua.SaftTaxCode = e.value)
                      }, null, 8, ["value"])
                    ]),
                    _createElementVNode("div", _hoisted_59, [
                      _createVNode(_component_DxTextBox, {
                        label: "Categorie TVA Motiv Scutire",
                        "label-mode": "floating",
                        value: _ctx.linieNoua.CategTvaMotivScutire,
                        onValueChanged: _cache[19] || (_cache[19] = (e) => _ctx.linieNoua.CategTvaMotivScutire = e.value)
                      }, null, 8, ["value"])
                    ]),
                    _createElementVNode("div", _hoisted_60, [
                      _createVNode(_component_DxTextBox, {
                        label: "Denumire Alternativă",
                        "label-mode": "floating",
                        value: _ctx.linieNoua.Nume,
                        onValueChanged: _cache[20] || (_cache[20] = (e) => _ctx.linieNoua.Nume = e.value)
                      }, null, 8, ["value"])
                    ])
                  ]))
                : (_ctx.document?.Categorie === 'Facturi client')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_61, [
                      _createElementVNode("div", _hoisted_62, [
                        _createVNode(_component_DxLookup, {
                          label: "Produs",
                          "label-mode": "floating",
                          "data-source": _ctx.dsProdus,
                          "value-expr": "Id",
                          "display-expr": _ctx.produsDisplayExpr,
                          "search-expr": ['Cod', 'CodIntern', 'Nume'],
                          "show-clear-button": true,
                          "search-enabled": true,
                          value: _ctx.linieNoua.ProdusId,
                          onValueChanged: _ctx.onValueChangedProdus,
                          "drop-down-options": { width: 'auto' }
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_DxDropDownOptions, { "show-title": false })
                          ]),
                          _: 1
                        }, 8, ["data-source", "display-expr", "value", "onValueChanged"])
                      ]),
                      _createElementVNode("div", _hoisted_63, [
                        _createVNode(_component_DxNumberBox, {
                          label: "Cantitate",
                          "label-mode": "floating",
                          value: _ctx.linieNoua.Cantitate,
                          min: 0,
                          "show-spin-buttons": true,
                          "show-clear-button": true,
                          onValueChanged: _cache[21] || (_cache[21] = (e) => { _ctx.linieNoua.Cantitate = e.value; _ctx.calculateTotalsLinie(); })
                        }, null, 8, ["value"])
                      ]),
                      _createElementVNode("div", _hoisted_64, [
                        _createVNode(_component_DxLookup, {
                          label: "Unitate",
                          "label-mode": "floating",
                          "data-source": _ctx.dsUnitate,
                          "value-expr": "Id",
                          "display-expr": "Simbol",
                          "show-clear-button": true,
                          "search-enabled": true,
                          value: _ctx.linieNoua.UnitateId,
                          "onUpdate:value": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.linieNoua.UnitateId) = $event))
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_DxDropDownOptions, { "show-title": false })
                          ]),
                          _: 1
                        }, 8, ["data-source", "value"])
                      ]),
                      _createElementVNode("div", _hoisted_65, [
                        _createVNode(_component_DxNumberBox, {
                          label: "Pret Unitar",
                          "label-mode": "floating",
                          value: _ctx.linieNoua.PretUnitar,
                          min: 0,
                          "show-spin-buttons": true,
                          "show-clear-button": true,
                          format: { type: 'fixedPoint', precision: 4 },
                          onValueChanged: _cache[23] || (_cache[23] = (e) => { _ctx.linieNoua.PretUnitar = e.value; _ctx.calculateTotalsLinie(); })
                        }, null, 8, ["value"])
                      ]),
                      _createElementVNode("div", _hoisted_66, [
                        _createVNode(_component_DxNumberBox, {
                          label: "TVA %",
                          "label-mode": "floating",
                          value: _ctx.linieNoua.Tva,
                          "onUpdate:value": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.linieNoua.Tva) = $event)),
                          min: 0,
                          step: 1,
                          "show-spin-buttons": true,
                          "show-clear-button": true,
                          format: "## '%'",
                          onValueChanged: _cache[25] || (_cache[25] = (e) => { _ctx.linieNoua.Tva = e.value; _ctx.calculateTotalsLinie(); })
                        }, null, 8, ["value"])
                      ]),
                      _createElementVNode("div", _hoisted_67, [
                        _createVNode(_component_DxLookup, {
                          label: "Categorie Contabilă",
                          "label-mode": "floating",
                          "data-source": _ctx.dsCategorieContabila,
                          "value-expr": "Id",
                          "display-expr": "Nume",
                          "show-clear-button": true,
                          "search-enabled": true,
                          value: _ctx.linieNoua.CategorieContabilaId,
                          onValueChanged: _cache[26] || (_cache[26] = (e) => _ctx.linieNoua.CategorieContabilaId = e.value),
                          "drop-down-options": { width: 'auto' }
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_DxDropDownOptions, { "show-title": false })
                          ]),
                          _: 1
                        }, 8, ["data-source", "value"])
                      ]),
                      _createElementVNode("div", _hoisted_68, [
                        _createVNode(_component_DxNumberBox, {
                          label: "Adaos/Discount %",
                          "label-mode": "floating",
                          value: _ctx.linieNoua.Adaos,
                          "onUpdate:value": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.linieNoua.Adaos) = $event)),
                          step: 1,
                          "show-spin-buttons": true,
                          "show-clear-button": true,
                          format: "## '%'"
                        }, null, 8, ["value"])
                      ]),
                      _createElementVNode("div", _hoisted_69, [
                        _createVNode(_component_DxNumberBox, {
                          label: "Adaos/Discount Unitar",
                          "label-mode": "floating",
                          value: _ctx.linieNoua.AdaosUnitar,
                          "onUpdate:value": _cache[28] || (_cache[28] = ($event: any) => ((_ctx.linieNoua.AdaosUnitar) = $event)),
                          "show-spin-buttons": true,
                          "show-clear-button": true,
                          format: { type: 'fixedPoint', precision: 4 }
                        }, null, 8, ["value"])
                      ]),
                      _createElementVNode("div", _hoisted_70, [
                        _createVNode(_component_DxNumberBox, {
                          label: "Valoare Adaos/Discount",
                          "label-mode": "floating",
                          value: _ctx.linieNoua.ValoareAdaos,
                          "onUpdate:value": _cache[29] || (_cache[29] = ($event: any) => ((_ctx.linieNoua.ValoareAdaos) = $event)),
                          "show-spin-buttons": true,
                          "show-clear-button": true,
                          format: "#,##0.00"
                        }, null, 8, ["value"])
                      ]),
                      _createElementVNode("div", _hoisted_71, [
                        _createVNode(_component_DxTextBox, {
                          label: "Categorie TVA",
                          "label-mode": "floating",
                          value: _ctx.linieNoua.CategTva,
                          onValueChanged: _cache[30] || (_cache[30] = (e) => _ctx.linieNoua.CategTva = e.value)
                        }, null, 8, ["value"])
                      ]),
                      _createElementVNode("div", _hoisted_72, [
                        _createVNode(_component_DxTextBox, {
                          label: "Cod TVA (SAF-T)",
                          "label-mode": "floating",
                          value: _ctx.linieNoua.SaftTaxCode,
                          onValueChanged: _cache[31] || (_cache[31] = (e) => _ctx.linieNoua.SaftTaxCode = e.value)
                        }, null, 8, ["value"])
                      ]),
                      _createElementVNode("div", _hoisted_73, [
                        _createVNode(_component_DxTextBox, {
                          label: "Categorie TVA Motiv Scutire",
                          "label-mode": "floating",
                          value: _ctx.linieNoua.CategTvaMotivScutire,
                          onValueChanged: _cache[32] || (_cache[32] = (e) => _ctx.linieNoua.CategTvaMotivScutire = e.value)
                        }, null, 8, ["value"])
                      ]),
                      _createElementVNode("div", _hoisted_74, [
                        _createVNode(_component_DxTextBox, {
                          label: "Denumire Alternativă",
                          "label-mode": "floating",
                          value: _ctx.linieNoua.Nume,
                          onValueChanged: _cache[33] || (_cache[33] = (e) => _ctx.linieNoua.Nume = e.value)
                        }, null, 8, ["value"])
                      ]),
                      _createElementVNode("div", _hoisted_75, [
                        _createVNode(_component_DxTextBox, {
                          label: "Explicatie",
                          "label-mode": "floating",
                          value: _ctx.linieNoua.Custom,
                          onValueChanged: _cache[34] || (_cache[34] = (e) => _ctx.linieNoua.Custom = e.value)
                        }, null, 8, ["value"])
                      ])
                    ]))
                  : (_ctx.document?.Categorie === 'Mijloace fixe')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_76, [
                        _createElementVNode("div", _hoisted_77, [
                          _createVNode(_component_DxLookup, {
                            label: "Produs",
                            "label-mode": "floating",
                            "data-source": _ctx.dsProdus,
                            "value-expr": "Id",
                            "display-expr": _ctx.produsDisplayExpr,
                            "search-expr": ['Cod', 'CodIntern', 'Nume'],
                            "show-clear-button": true,
                            "search-enabled": true,
                            value: _ctx.linieNoua.ProdusId,
                            onValueChanged: _ctx.onValueChangedProdus,
                            "drop-down-options": { width: 'auto' }
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_DxDropDownOptions, { "show-title": false })
                            ]),
                            _: 1
                          }, 8, ["data-source", "display-expr", "value", "onValueChanged"])
                        ]),
                        _createElementVNode("div", _hoisted_78, [
                          _createVNode(_component_DxNumberBox, {
                            label: "Cantitate",
                            "label-mode": "floating",
                            value: _ctx.linieNoua.Cantitate,
                            min: 0,
                            "show-spin-buttons": true,
                            "show-clear-button": true,
                            onValueChanged: _cache[35] || (_cache[35] = (e) => { _ctx.linieNoua.Cantitate = e.value; _ctx.calculateTotalsLinie(); })
                          }, null, 8, ["value"])
                        ]),
                        _createElementVNode("div", _hoisted_79, [
                          _createVNode(_component_DxLookup, {
                            label: "Unitate",
                            "label-mode": "floating",
                            "data-source": _ctx.dsUnitate,
                            "value-expr": "Id",
                            "display-expr": "Simbol",
                            "show-clear-button": true,
                            "search-enabled": true,
                            value: _ctx.linieNoua.UnitateId,
                            "onUpdate:value": _cache[36] || (_cache[36] = ($event: any) => ((_ctx.linieNoua.UnitateId) = $event))
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_DxDropDownOptions, { "show-title": false })
                            ]),
                            _: 1
                          }, 8, ["data-source", "value"])
                        ]),
                        _createElementVNode("div", _hoisted_80, [
                          _createVNode(_component_DxNumberBox, {
                            label: "Pret Unitar",
                            "label-mode": "floating",
                            value: _ctx.linieNoua.PretUnitar,
                            min: 0,
                            "show-spin-buttons": true,
                            "show-clear-button": true,
                            format: { type: 'fixedPoint', precision: 4 },
                            onValueChanged: _cache[37] || (_cache[37] = (e) => { _ctx.linieNoua.PretUnitar = e.value; _ctx.calculateTotalsLinie(); })
                          }, null, 8, ["value"])
                        ]),
                        _createElementVNode("div", _hoisted_81, [
                          _createVNode(_component_DxNumberBox, {
                            label: "Adaos/Discount Unitar",
                            "label-mode": "floating",
                            value: _ctx.linieNoua.AdaosUnitar,
                            "onUpdate:value": _cache[38] || (_cache[38] = ($event: any) => ((_ctx.linieNoua.AdaosUnitar) = $event)),
                            "show-spin-buttons": true,
                            "show-clear-button": true,
                            format: { type: 'fixedPoint', precision: 4 }
                          }, null, 8, ["value"])
                        ]),
                        _createElementVNode("div", _hoisted_82, [
                          _createVNode(_component_DxLookup, {
                            label: "Categorie Contabilă",
                            "label-mode": "floating",
                            "data-source": _ctx.dsCategorieContabila,
                            "value-expr": "Id",
                            "display-expr": "Nume",
                            "show-clear-button": true,
                            "search-enabled": true,
                            value: _ctx.linieNoua.CategorieContabilaId,
                            onValueChanged: _cache[39] || (_cache[39] = (e) => _ctx.linieNoua.CategorieContabilaId = e.value),
                            "drop-down-options": { width: 'auto' }
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_DxDropDownOptions, { "show-title": false })
                            ]),
                            _: 1
                          }, 8, ["data-source", "value"])
                        ]),
                        _createElementVNode("div", _hoisted_83, [
                          _createVNode(_component_DxTextBox, {
                            label: "Denumire Alternativă",
                            "label-mode": "floating",
                            value: _ctx.linieNoua.Nume,
                            onValueChanged: _cache[40] || (_cache[40] = (e) => _ctx.linieNoua.Nume = e.value)
                          }, null, 8, ["value"])
                        ])
                      ]))
                    : (_ctx.document?.Categorie === 'Documente gestiune')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_84, [
                          _createElementVNode("div", _hoisted_85, [
                            _createVNode(_component_DxLookup, {
                              label: "Produs",
                              "label-mode": "floating",
                              "data-source": _ctx.dsProdus,
                              "value-expr": "Id",
                              "display-expr": _ctx.produsDisplayExpr,
                              "search-expr": ['Cod', 'CodIntern', 'Nume'],
                              "show-clear-button": true,
                              "search-enabled": true,
                              value: _ctx.linieNoua.ProdusId,
                              onValueChanged: _ctx.onValueChangedProdus,
                              "drop-down-options": { width: 'auto' }
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_DxDropDownOptions, { "show-title": false })
                              ]),
                              _: 1
                            }, 8, ["data-source", "display-expr", "value", "onValueChanged"])
                          ]),
                          _createElementVNode("div", _hoisted_86, [
                            _createVNode(_component_DxNumberBox, {
                              label: "Cantitate",
                              "label-mode": "floating",
                              value: _ctx.linieNoua.Cantitate,
                              min: 0,
                              "show-spin-buttons": true,
                              "show-clear-button": true,
                              onValueChanged: _cache[41] || (_cache[41] = (e) => { _ctx.linieNoua.Cantitate = e.value; _ctx.calculateTotalsLinie(); })
                            }, null, 8, ["value"])
                          ]),
                          _createElementVNode("div", _hoisted_87, [
                            _createVNode(_component_DxLookup, {
                              label: "Unitate",
                              "label-mode": "floating",
                              "data-source": _ctx.dsUnitate,
                              "value-expr": "Id",
                              "display-expr": "Simbol",
                              "show-clear-button": true,
                              "search-enabled": true,
                              value: _ctx.linieNoua.UnitateId,
                              "onUpdate:value": _cache[42] || (_cache[42] = ($event: any) => ((_ctx.linieNoua.UnitateId) = $event))
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_DxDropDownOptions, { "show-title": false })
                              ]),
                              _: 1
                            }, 8, ["data-source", "value"])
                          ]),
                          _createElementVNode("div", _hoisted_88, [
                            _createVNode(_component_DxNumberBox, {
                              label: "Pret Unitar",
                              "label-mode": "floating",
                              value: _ctx.linieNoua.PretUnitar,
                              min: 0,
                              "show-spin-buttons": true,
                              "show-clear-button": true,
                              format: { type: 'fixedPoint', precision: 4 },
                              onValueChanged: _cache[43] || (_cache[43] = (e) => { _ctx.linieNoua.PretUnitar = e.value; _ctx.calculateTotalsLinie(); })
                            }, null, 8, ["value"])
                          ]),
                          _createElementVNode("div", _hoisted_89, [
                            _createVNode(_component_DxNumberBox, {
                              label: "Valoare",
                              "label-mode": "floating",
                              value: _ctx.linieNoua.Valoare,
                              "onUpdate:value": _cache[44] || (_cache[44] = ($event: any) => ((_ctx.linieNoua.Valoare) = $event)),
                              "show-spin-buttons": true,
                              "show-clear-button": true,
                              format: "#,##0.00",
                              disabled: true
                            }, null, 8, ["value"])
                          ]),
                          _createElementVNode("div", _hoisted_90, [
                            _createVNode(_component_DxNumberBox, {
                              label: "Adaos/Discount Unitar",
                              "label-mode": "floating",
                              value: _ctx.linieNoua.AdaosUnitar,
                              "onUpdate:value": _cache[45] || (_cache[45] = ($event: any) => ((_ctx.linieNoua.AdaosUnitar) = $event)),
                              "show-spin-buttons": true,
                              "show-clear-button": true,
                              format: { type: 'fixedPoint', precision: 4 }
                            }, null, 8, ["value"])
                          ]),
                          _createElementVNode("div", _hoisted_91, [
                            _createVNode(_component_DxLookup, {
                              label: "Scop Operational",
                              "label-mode": "floating",
                              "data-source": _ctx.dsCustomList,
                              "value-expr": "Id",
                              "display-expr": "Nume",
                              "show-clear-button": true,
                              "search-enabled": true,
                              value: _ctx.linieNoua.CustomId,
                              onValueChanged: _cache[46] || (_cache[46] = (e) => _ctx.linieNoua.CustomId = e.value),
                              "drop-down-options": { width: 'auto' }
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_DxDropDownOptions, { "show-title": false })
                              ]),
                              _: 1
                            }, 8, ["data-source", "value"])
                          ]),
                          _createElementVNode("div", _hoisted_92, [
                            _createVNode(_component_DxLookup, {
                              label: "Categorie Contabilă",
                              "label-mode": "floating",
                              "data-source": _ctx.dsCategorieContabila,
                              "value-expr": "Id",
                              "display-expr": "Nume",
                              "show-clear-button": true,
                              "search-enabled": true,
                              value: _ctx.linieNoua.CategorieContabilaId,
                              onValueChanged: _cache[47] || (_cache[47] = (e) => _ctx.linieNoua.CategorieContabilaId = e.value),
                              "drop-down-options": { width: 'auto' }
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_DxDropDownOptions, { "show-title": false })
                              ]),
                              _: 1
                            }, 8, ["data-source", "value"])
                          ]),
                          _createElementVNode("div", _hoisted_93, [
                            _createVNode(_component_DxNumberBox, {
                              label: "Garantie Luni",
                              "label-mode": "floating",
                              value: _ctx.linieNoua.GarantieLuni,
                              "onUpdate:value": _cache[48] || (_cache[48] = ($event: any) => ((_ctx.linieNoua.GarantieLuni) = $event)),
                              min: 0,
                              "show-spin-buttons": true,
                              "show-clear-button": true
                            }, null, 8, ["value"])
                          ]),
                          _createElementVNode("div", _hoisted_94, [
                            _createVNode(_component_DxTextBox, {
                              label: "Cod NC8",
                              "label-mode": "floating",
                              value: _ctx.linieNoua.CodNc8,
                              onValueChanged: _cache[49] || (_cache[49] = (e) => _ctx.linieNoua.CodNc8 = e.value)
                            }, null, 8, ["value"])
                          ]),
                          _createElementVNode("div", _hoisted_95, [
                            _createVNode(_component_DxNumberBox, {
                              label: "Masa Net",
                              "label-mode": "floating",
                              value: _ctx.linieNoua.MasaNet,
                              "onUpdate:value": _cache[50] || (_cache[50] = ($event: any) => ((_ctx.linieNoua.MasaNet) = $event)),
                              "show-spin-buttons": true,
                              "show-clear-button": true,
                              format: { type: 'fixedPoint', precision: 4 }
                            }, null, 8, ["value"])
                          ]),
                          _createElementVNode("div", _hoisted_96, [
                            _createVNode(_component_DxNumberBox, {
                              label: "Masa Brut",
                              "label-mode": "floating",
                              value: _ctx.linieNoua.MasaBrut,
                              "onUpdate:value": _cache[51] || (_cache[51] = ($event: any) => ((_ctx.linieNoua.MasaBrut) = $event)),
                              "show-spin-buttons": true,
                              "show-clear-button": true,
                              format: { type: 'fixedPoint', precision: 4 }
                            }, null, 8, ["value"])
                          ]),
                          _createElementVNode("div", _hoisted_97, [
                            _createVNode(_component_DxTextBox, {
                              label: "Denumire Alternativă",
                              "label-mode": "floating",
                              value: _ctx.linieNoua.Nume,
                              onValueChanged: _cache[52] || (_cache[52] = (e) => _ctx.linieNoua.Nume = e.value)
                            }, null, 8, ["value"])
                          ])
                        ]))
                      : (_ctx.document?.Categorie === 'Personal - Salarizare')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_98, [
                            _createElementVNode("div", _hoisted_99, [
                              _createVNode(_component_DxLookup, {
                                label: "Produs",
                                "label-mode": "floating",
                                "data-source": _ctx.dsProdus,
                                "value-expr": "Id",
                                "display-expr": _ctx.produsDisplayExpr,
                                "search-expr": ['Cod', 'CodIntern', 'Nume'],
                                "show-clear-button": true,
                                "search-enabled": true,
                                value: _ctx.linieNoua.ProdusId,
                                onValueChanged: _ctx.onValueChangedProdus,
                                "drop-down-options": { width: 'auto' }
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_DxDropDownOptions, { "show-title": false })
                                ]),
                                _: 1
                              }, 8, ["data-source", "display-expr", "value", "onValueChanged"])
                            ]),
                            _createElementVNode("div", _hoisted_100, [
                              _createVNode(_component_DxNumberBox, {
                                label: "Cantitate",
                                "label-mode": "floating",
                                value: _ctx.linieNoua.Cantitate,
                                min: 0,
                                "show-spin-buttons": true,
                                "show-clear-button": true,
                                onValueChanged: _cache[53] || (_cache[53] = (e) => { _ctx.linieNoua.Cantitate = e.value; _ctx.calculateTotalsLinie(); })
                              }, null, 8, ["value"])
                            ]),
                            _createElementVNode("div", _hoisted_101, [
                              _createVNode(_component_DxLookup, {
                                label: "Unitate",
                                "label-mode": "floating",
                                "data-source": _ctx.dsUnitate,
                                "value-expr": "Id",
                                "display-expr": "Simbol",
                                "show-clear-button": true,
                                "search-enabled": true,
                                value: _ctx.linieNoua.UnitateId,
                                "onUpdate:value": _cache[54] || (_cache[54] = ($event: any) => ((_ctx.linieNoua.UnitateId) = $event))
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_DxDropDownOptions, { "show-title": false })
                                ]),
                                _: 1
                              }, 8, ["data-source", "value"])
                            ]),
                            _createElementVNode("div", _hoisted_102, [
                              _createVNode(_component_DxNumberBox, {
                                label: "Pret Unitar",
                                "label-mode": "floating",
                                value: _ctx.linieNoua.PretUnitar,
                                min: 0,
                                "show-spin-buttons": true,
                                "show-clear-button": true,
                                format: { type: 'fixedPoint', precision: 4 },
                                onValueChanged: _cache[55] || (_cache[55] = (e) => { _ctx.linieNoua.PretUnitar = e.value; _ctx.calculateTotalsLinie(); })
                              }, null, 8, ["value"])
                            ]),
                            _createElementVNode("div", _hoisted_103, [
                              _createVNode(_component_DxNumberBox, {
                                label: "Valoare",
                                "label-mode": "floating",
                                value: _ctx.linieNoua.Valoare,
                                "onUpdate:value": _cache[56] || (_cache[56] = ($event: any) => ((_ctx.linieNoua.Valoare) = $event)),
                                "show-spin-buttons": true,
                                "show-clear-button": true,
                                format: "#,##0.00",
                                disabled: true
                              }, null, 8, ["value"])
                            ]),
                            _createElementVNode("div", _hoisted_104, [
                              _createVNode(_component_DxNumberBox, {
                                label: "Adaos/Discount Unitar",
                                "label-mode": "floating",
                                value: _ctx.linieNoua.AdaosUnitar,
                                "onUpdate:value": _cache[57] || (_cache[57] = ($event: any) => ((_ctx.linieNoua.AdaosUnitar) = $event)),
                                "show-spin-buttons": true,
                                "show-clear-button": true,
                                format: { type: 'fixedPoint', precision: 4 }
                              }, null, 8, ["value"])
                            ]),
                            _createElementVNode("div", _hoisted_105, [
                              _createVNode(_component_DxNumberBox, {
                                label: "Total",
                                "label-mode": "floating",
                                value: _ctx.linieNoua.Total,
                                "onUpdate:value": _cache[58] || (_cache[58] = ($event: any) => ((_ctx.linieNoua.Total) = $event)),
                                "show-spin-buttons": true,
                                "show-clear-button": true,
                                format: "#,##0.00",
                                disabled: true
                              }, null, 8, ["value"])
                            ]),
                            _createElementVNode("div", _hoisted_106, [
                              _createVNode(_component_DxLookup, {
                                label: "Categorie Contabilă",
                                "label-mode": "floating",
                                "data-source": _ctx.dsCategorieContabila,
                                "value-expr": "Id",
                                "display-expr": "Nume",
                                "show-clear-button": true,
                                "search-enabled": true,
                                value: _ctx.linieNoua.CategorieContabilaId,
                                onValueChanged: _cache[59] || (_cache[59] = (e) => _ctx.linieNoua.CategorieContabilaId = e.value),
                                "drop-down-options": { width: 'auto' }
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_DxDropDownOptions, { "show-title": false })
                                ]),
                                _: 1
                              }, 8, ["data-source", "value"])
                            ]),
                            _createElementVNode("div", _hoisted_107, [
                              _createVNode(_component_DxDropDownBox, {
                                ref: "personalDepartamentBox",
                                label: "Departament",
                                "label-mode": "floating",
                                value: _ctx.linieNoua.StructIdEditabil,
                                "onUpdate:value": _cache[60] || (_cache[60] = ($event: any) => ((_ctx.linieNoua.StructIdEditabil) = $event)),
                                "data-source": _ctx.structuriIdEditabileItems,
                                "value-expr": "Id",
                                "display-expr": _ctx.departamentDisplayExpr,
                                "show-clear-button": true
                              }, {
                                content: _withCtx(() => [
                                  _createVNode(_component_DxTreeView, {
                                    items: _ctx.structuriIdEditabileTree,
                                    "key-expr": "Id",
                                    "display-expr": "Nume",
                                    "selection-mode": "single",
                                    "select-by-click": true,
                                    onItemClick: _ctx.onPersonalDepartamentSelect
                                  }, null, 8, ["items", "onItemClick"])
                                ]),
                                _: 1
                              }, 8, ["value", "data-source", "display-expr"])
                            ]),
                            _createElementVNode("div", _hoisted_108, [
                              _createVNode(_component_DxTextBox, {
                                label: "Denumire Alternativă",
                                "label-mode": "floating",
                                value: _ctx.linieNoua.Nume,
                                onValueChanged: _cache[61] || (_cache[61] = (e) => _ctx.linieNoua.Nume = e.value)
                              }, null, 8, ["value"])
                            ])
                          ]))
                        : (_ctx.document?.Categorie === 'Solduri Initiale')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_109, [
                              _createElementVNode("div", _hoisted_110, [
                                _createVNode(_component_DxLookup, {
                                  label: "Produs",
                                  "label-mode": "floating",
                                  "data-source": _ctx.dsProdus,
                                  "value-expr": "Id",
                                  "display-expr": _ctx.produsDisplayExpr,
                                  "search-expr": ['Cod', 'CodIntern', 'Nume'],
                                  "show-clear-button": true,
                                  "search-enabled": true,
                                  value: _ctx.linieNoua.ProdusId,
                                  onValueChanged: _ctx.onValueChangedProdus,
                                  "drop-down-options": { width: 'auto' }
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_DxDropDownOptions, { "show-title": false })
                                  ]),
                                  _: 1
                                }, 8, ["data-source", "display-expr", "value", "onValueChanged"])
                              ]),
                              _createElementVNode("div", _hoisted_111, [
                                _createVNode(_component_DxNumberBox, {
                                  label: "Cantitate",
                                  "label-mode": "floating",
                                  value: _ctx.linieNoua.Cantitate,
                                  min: 0,
                                  "show-spin-buttons": true,
                                  "show-clear-button": true,
                                  onValueChanged: _cache[62] || (_cache[62] = (e) => { _ctx.linieNoua.Cantitate = e.value; _ctx.calculateTotalsLinie(); })
                                }, null, 8, ["value"])
                              ]),
                              _createElementVNode("div", _hoisted_112, [
                                _createVNode(_component_DxLookup, {
                                  label: "Unitate",
                                  "label-mode": "floating",
                                  "data-source": _ctx.dsUnitate,
                                  "value-expr": "Id",
                                  "display-expr": "Simbol",
                                  "show-clear-button": true,
                                  "search-enabled": true,
                                  value: _ctx.linieNoua.UnitateId,
                                  "onUpdate:value": _cache[63] || (_cache[63] = ($event: any) => ((_ctx.linieNoua.UnitateId) = $event))
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_DxDropDownOptions, { "show-title": false })
                                  ]),
                                  _: 1
                                }, 8, ["data-source", "value"])
                              ]),
                              _createElementVNode("div", _hoisted_113, [
                                _createVNode(_component_DxNumberBox, {
                                  label: "Pret Unitar",
                                  "label-mode": "floating",
                                  value: _ctx.linieNoua.PretUnitar,
                                  min: 0,
                                  "show-spin-buttons": true,
                                  "show-clear-button": true,
                                  format: { type: 'fixedPoint', precision: 4 },
                                  onValueChanged: _cache[64] || (_cache[64] = (e) => { _ctx.linieNoua.PretUnitar = e.value; _ctx.calculateTotalsLinie(); })
                                }, null, 8, ["value"])
                              ]),
                              _createElementVNode("div", _hoisted_114, [
                                _createVNode(_component_DxNumberBox, {
                                  label: "Valoare",
                                  "label-mode": "floating",
                                  value: _ctx.linieNoua.Valoare,
                                  "onUpdate:value": _cache[65] || (_cache[65] = ($event: any) => ((_ctx.linieNoua.Valoare) = $event)),
                                  format: "#,##0.00",
                                  disabled: true
                                }, null, 8, ["value"])
                              ]),
                              _createElementVNode("div", _hoisted_115, [
                                _createVNode(_component_DxNumberBox, {
                                  label: "Adaos/Discount Unitar",
                                  "label-mode": "floating",
                                  value: _ctx.linieNoua.AdaosUnitar,
                                  "onUpdate:value": _cache[66] || (_cache[66] = ($event: any) => ((_ctx.linieNoua.AdaosUnitar) = $event)),
                                  "show-spin-buttons": true,
                                  "show-clear-button": true,
                                  format: { type: 'fixedPoint', precision: 4 }
                                }, null, 8, ["value"])
                              ]),
                              _createElementVNode("div", _hoisted_116, [
                                _createVNode(_component_DxNumberBox, {
                                  label: "Total",
                                  "label-mode": "floating",
                                  value: _ctx.linieNoua.Total,
                                  "onUpdate:value": _cache[67] || (_cache[67] = ($event: any) => ((_ctx.linieNoua.Total) = $event)),
                                  format: "#,##0.00",
                                  disabled: true
                                }, null, 8, ["value"])
                              ]),
                              _createElementVNode("div", _hoisted_117, [
                                _createVNode(_component_DxTextBox, {
                                  label: "Loc Depozitare",
                                  "label-mode": "floating",
                                  value: _ctx.linieNoua.LocDepozitare,
                                  "onUpdate:value": _cache[68] || (_cache[68] = ($event: any) => ((_ctx.linieNoua.LocDepozitare) = $event))
                                }, null, 8, ["value"])
                              ]),
                              _createElementVNode("div", _hoisted_118, [
                                _createVNode(_component_DxLookup, {
                                  label: "Categorie Contabila",
                                  "label-mode": "floating",
                                  "data-source": _ctx.dsCategorieContabila,
                                  "value-expr": "Id",
                                  "display-expr": "Nume",
                                  "show-clear-button": true,
                                  "search-enabled": true,
                                  value: _ctx.linieNoua.CategorieContabilaId,
                                  onValueChanged: _cache[69] || (_cache[69] = (e) => _ctx.linieNoua.CategorieContabilaId = e.value),
                                  "drop-down-options": { width: 'auto' }
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_DxDropDownOptions, { "show-title": false })
                                  ]),
                                  _: 1
                                }, 8, ["data-source", "value"])
                              ]),
                              _createElementVNode("div", _hoisted_119, [
                                _createVNode(_component_DxLookup, {
                                  label: "UM FA",
                                  "label-mode": "floating",
                                  "data-source": _ctx.dsUnitate,
                                  "value-expr": "Id",
                                  "display-expr": "Simbol",
                                  "show-clear-button": true,
                                  "search-enabled": true,
                                  value: _ctx.linieNoua.UnitateAmbalajId,
                                  "onUpdate:value": _cache[70] || (_cache[70] = ($event: any) => ((_ctx.linieNoua.UnitateAmbalajId) = $event))
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_DxDropDownOptions, { "show-title": false })
                                  ]),
                                  _: 1
                                }, 8, ["data-source", "value"])
                              ]),
                              _createElementVNode("div", _hoisted_120, [
                                _createVNode(_component_DxNumberBox, {
                                  label: "Cantitate pentru 1 FA",
                                  "label-mode": "floating",
                                  value: _ctx.linieNoua.CantitatePt1Fa,
                                  "onUpdate:value": _cache[71] || (_cache[71] = ($event: any) => ((_ctx.linieNoua.CantitatePt1Fa) = $event)),
                                  "show-spin-buttons": true,
                                  "show-clear-button": true,
                                  format: "#,##0.00"
                                }, null, 8, ["value"])
                              ]),
                              _createElementVNode("div", _hoisted_121, [
                                _createVNode(_component_DxNumberBox, {
                                  label: "Cantitate FA",
                                  "label-mode": "floating",
                                  value: _ctx.linieNoua.CantitateFa,
                                  "onUpdate:value": _cache[72] || (_cache[72] = ($event: any) => ((_ctx.linieNoua.CantitateFa) = $event)),
                                  "show-spin-buttons": true,
                                  "show-clear-button": true,
                                  format: "#,##0.00"
                                }, null, 8, ["value"])
                              ]),
                              _createElementVNode("div", _hoisted_122, [
                                _createVNode(_component_DxNumberBox, {
                                  label: "Etichete",
                                  "label-mode": "floating",
                                  value: _ctx.linieNoua.CantitateFa,
                                  format: "#,##0.00",
                                  disabled: true
                                }, null, 8, ["value"])
                              ]),
                              _createElementVNode("div", _hoisted_123, [
                                _createVNode(_component_DxNumberBox, {
                                  label: "Taxa Unitara",
                                  "label-mode": "floating",
                                  value: _ctx.linieNoua.TaxaUnitara,
                                  "onUpdate:value": _cache[73] || (_cache[73] = ($event: any) => ((_ctx.linieNoua.TaxaUnitara) = $event)),
                                  "show-spin-buttons": true,
                                  "show-clear-button": true,
                                  format: { type: 'fixedPoint', precision: 4 }
                                }, null, 8, ["value"])
                              ]),
                              _createElementVNode("div", _hoisted_124, [
                                _createVNode(_component_DxTextBox, {
                                  label: "Lot Furnizor",
                                  "label-mode": "floating",
                                  value: _ctx.linieNoua.CodLotFurnizor,
                                  "onUpdate:value": _cache[74] || (_cache[74] = ($event: any) => ((_ctx.linieNoua.CodLotFurnizor) = $event))
                                }, null, 8, ["value"])
                              ]),
                              _createElementVNode("div", _hoisted_125, [
                                _createVNode(_component_DxTextBox, {
                                  label: "Lot Intern",
                                  "label-mode": "floating",
                                  value: _ctx.linieNoua.CodLotIntern,
                                  "onUpdate:value": _cache[75] || (_cache[75] = ($event: any) => ((_ctx.linieNoua.CodLotIntern) = $event))
                                }, null, 8, ["value"])
                              ]),
                              _createElementVNode("div", _hoisted_126, [
                                _createVNode(_component_DxDateBox, {
                                  label: "Data Expirarii",
                                  "label-mode": "floating",
                                  value: _ctx.linieNoua.DataExp,
                                  "onUpdate:value": _cache[76] || (_cache[76] = ($event: any) => ((_ctx.linieNoua.DataExp) = $event)),
                                  "display-format": "dd.MM.yyyy",
                                  "show-clear-button": true
                                }, null, 8, ["value"])
                              ]),
                              _createElementVNode("div", _hoisted_127, [
                                _createVNode(_component_DxTextBox, {
                                  label: "Denumire Alternativa",
                                  "label-mode": "floating",
                                  value: _ctx.linieNoua.Nume,
                                  onValueChanged: _cache[77] || (_cache[77] = (e) => _ctx.linieNoua.Nume = e.value)
                                }, null, 8, ["value"])
                              ])
                            ]))
                          : (_ctx.document?.Categorie === 'Documente productie')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_128, [
                                _createElementVNode("div", _hoisted_129, [
                                  _createVNode(_component_DxLookup, {
                                    label: "Produs",
                                    "label-mode": "floating",
                                    "data-source": _ctx.dsProdus,
                                    "value-expr": "Id",
                                    "display-expr": _ctx.produsDisplayExpr,
                                    "search-expr": ['Cod', 'CodIntern', 'Nume'],
                                    "show-clear-button": true,
                                    "search-enabled": true,
                                    value: _ctx.linieNoua.ProdusId,
                                    onValueChanged: _ctx.onValueChangedProdus,
                                    "drop-down-options": { width: 'auto' }
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_DxDropDownOptions, { "show-title": false })
                                    ]),
                                    _: 1
                                  }, 8, ["data-source", "display-expr", "value", "onValueChanged"])
                                ]),
                                _createElementVNode("div", _hoisted_130, [
                                  _createVNode(_component_DxNumberBox, {
                                    label: "Cantitate",
                                    "label-mode": "floating",
                                    value: _ctx.linieNoua.Cantitate,
                                    min: 0,
                                    "show-spin-buttons": true,
                                    "show-clear-button": true,
                                    onValueChanged: _cache[78] || (_cache[78] = (e) => { _ctx.linieNoua.Cantitate = e.value; _ctx.calculateTotalsLinie(); })
                                  }, null, 8, ["value"])
                                ]),
                                _createElementVNode("div", _hoisted_131, [
                                  _createVNode(_component_DxLookup, {
                                    label: "Unitate",
                                    "label-mode": "floating",
                                    "data-source": _ctx.dsUnitate,
                                    "value-expr": "Id",
                                    "display-expr": "Simbol",
                                    "show-clear-button": true,
                                    "search-enabled": true,
                                    value: _ctx.linieNoua.UnitateId,
                                    "onUpdate:value": _cache[79] || (_cache[79] = ($event: any) => ((_ctx.linieNoua.UnitateId) = $event))
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_DxDropDownOptions, { "show-title": false })
                                    ]),
                                    _: 1
                                  }, 8, ["data-source", "value"])
                                ]),
                                _createElementVNode("div", _hoisted_132, [
                                  _createVNode(_component_DxNumberBox, {
                                    label: "Pret Unitar",
                                    "label-mode": "floating",
                                    value: _ctx.linieNoua.PretUnitar,
                                    min: 0,
                                    "show-spin-buttons": true,
                                    "show-clear-button": true,
                                    format: { type: 'fixedPoint', precision: 4 },
                                    onValueChanged: _cache[80] || (_cache[80] = (e) => { _ctx.linieNoua.PretUnitar = e.value; _ctx.calculateTotalsLinie(); })
                                  }, null, 8, ["value"])
                                ]),
                                _createElementVNode("div", _hoisted_133, [
                                  _createVNode(_component_DxNumberBox, {
                                    label: "Valoare",
                                    "label-mode": "floating",
                                    value: _ctx.linieNoua.Valoare,
                                    "onUpdate:value": _cache[81] || (_cache[81] = ($event: any) => ((_ctx.linieNoua.Valoare) = $event)),
                                    format: "#,##0.00",
                                    disabled: true
                                  }, null, 8, ["value"])
                                ]),
                                _createElementVNode("div", _hoisted_134, [
                                  _createVNode(_component_DxNumberBox, {
                                    label: "Adaos/Discount Unitar",
                                    "label-mode": "floating",
                                    value: _ctx.linieNoua.AdaosUnitar,
                                    "onUpdate:value": _cache[82] || (_cache[82] = ($event: any) => ((_ctx.linieNoua.AdaosUnitar) = $event)),
                                    "show-spin-buttons": true,
                                    "show-clear-button": true,
                                    format: { type: 'fixedPoint', precision: 4 }
                                  }, null, 8, ["value"])
                                ]),
                                _createElementVNode("div", _hoisted_135, [
                                  _createVNode(_component_DxNumberBox, {
                                    label: "Total",
                                    "label-mode": "floating",
                                    value: _ctx.linieNoua.Total,
                                    "onUpdate:value": _cache[83] || (_cache[83] = ($event: any) => ((_ctx.linieNoua.Total) = $event)),
                                    format: "#,##0.00",
                                    disabled: true
                                  }, null, 8, ["value"])
                                ]),
                                _createElementVNode("div", _hoisted_136, [
                                  _createVNode(_component_DxTextBox, {
                                    label: "Loc Depozitare",
                                    "label-mode": "floating",
                                    value: _ctx.linieNoua.LocDepozitare,
                                    "onUpdate:value": _cache[84] || (_cache[84] = ($event: any) => ((_ctx.linieNoua.LocDepozitare) = $event))
                                  }, null, 8, ["value"])
                                ]),
                                _createElementVNode("div", _hoisted_137, [
                                  _createVNode(_component_DxLookup, {
                                    label: "Categorie Contabila",
                                    "label-mode": "floating",
                                    "data-source": _ctx.dsCategorieContabila,
                                    "value-expr": "Id",
                                    "display-expr": "Nume",
                                    "show-clear-button": true,
                                    "search-enabled": true,
                                    value: _ctx.linieNoua.CategorieContabilaId,
                                    onValueChanged: _cache[85] || (_cache[85] = (e) => _ctx.linieNoua.CategorieContabilaId = e.value),
                                    "drop-down-options": { width: 'auto' }
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_DxDropDownOptions, { "show-title": false })
                                    ]),
                                    _: 1
                                  }, 8, ["data-source", "value"])
                                ]),
                                _createElementVNode("div", _hoisted_138, [
                                  _createVNode(_component_DxLookup, {
                                    label: "UM FA",
                                    "label-mode": "floating",
                                    "data-source": _ctx.dsUnitate,
                                    "value-expr": "Id",
                                    "display-expr": "Simbol",
                                    "show-clear-button": true,
                                    "search-enabled": true,
                                    value: _ctx.linieNoua.UnitateAmbalajId,
                                    "onUpdate:value": _cache[86] || (_cache[86] = ($event: any) => ((_ctx.linieNoua.UnitateAmbalajId) = $event))
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_DxDropDownOptions, { "show-title": false })
                                    ]),
                                    _: 1
                                  }, 8, ["data-source", "value"])
                                ]),
                                _createElementVNode("div", _hoisted_139, [
                                  _createVNode(_component_DxNumberBox, {
                                    label: "Cantitate pentru 1 FA",
                                    "label-mode": "floating",
                                    value: _ctx.linieNoua.CantitatePt1Fa,
                                    "onUpdate:value": _cache[87] || (_cache[87] = ($event: any) => ((_ctx.linieNoua.CantitatePt1Fa) = $event)),
                                    "show-spin-buttons": true,
                                    "show-clear-button": true,
                                    format: "#,##0.00"
                                  }, null, 8, ["value"])
                                ]),
                                _createElementVNode("div", _hoisted_140, [
                                  _createVNode(_component_DxNumberBox, {
                                    label: "Cantitate FA",
                                    "label-mode": "floating",
                                    value: _ctx.linieNoua.CantitateFa,
                                    "onUpdate:value": _cache[88] || (_cache[88] = ($event: any) => ((_ctx.linieNoua.CantitateFa) = $event)),
                                    "show-spin-buttons": true,
                                    "show-clear-button": true,
                                    format: "#,##0.00"
                                  }, null, 8, ["value"])
                                ]),
                                _createElementVNode("div", _hoisted_141, [
                                  _createVNode(_component_DxNumberBox, {
                                    label: "Etichete",
                                    "label-mode": "floating",
                                    value: _ctx.linieNoua.CantitateFa,
                                    format: "#,##0.00",
                                    disabled: true
                                  }, null, 8, ["value"])
                                ]),
                                _createElementVNode("div", _hoisted_142, [
                                  _createVNode(_component_DxNumberBox, {
                                    label: "Taxa Unitara",
                                    "label-mode": "floating",
                                    value: _ctx.linieNoua.TaxaUnitara,
                                    "onUpdate:value": _cache[89] || (_cache[89] = ($event: any) => ((_ctx.linieNoua.TaxaUnitara) = $event)),
                                    "show-spin-buttons": true,
                                    "show-clear-button": true,
                                    format: { type: 'fixedPoint', precision: 4 }
                                  }, null, 8, ["value"])
                                ]),
                                _createElementVNode("div", _hoisted_143, [
                                  _createVNode(_component_DxTextBox, {
                                    label: "Lot Furnizor",
                                    "label-mode": "floating",
                                    value: _ctx.linieNoua.CodLotFurnizor,
                                    "onUpdate:value": _cache[90] || (_cache[90] = ($event: any) => ((_ctx.linieNoua.CodLotFurnizor) = $event))
                                  }, null, 8, ["value"])
                                ]),
                                _createElementVNode("div", _hoisted_144, [
                                  _createVNode(_component_DxTextBox, {
                                    label: "Lot Intern",
                                    "label-mode": "floating",
                                    value: _ctx.linieNoua.CodLotIntern,
                                    "onUpdate:value": _cache[91] || (_cache[91] = ($event: any) => ((_ctx.linieNoua.CodLotIntern) = $event))
                                  }, null, 8, ["value"])
                                ]),
                                _createElementVNode("div", _hoisted_145, [
                                  _createVNode(_component_DxDateBox, {
                                    label: "Data Expirarii",
                                    "label-mode": "floating",
                                    value: _ctx.linieNoua.DataExp,
                                    "onUpdate:value": _cache[92] || (_cache[92] = ($event: any) => ((_ctx.linieNoua.DataExp) = $event)),
                                    "display-format": "dd.MM.yyyy",
                                    "show-clear-button": true
                                  }, null, 8, ["value"])
                                ]),
                                _createElementVNode("div", _hoisted_146, [
                                  _createVNode(_component_DxTextBox, {
                                    label: "Denumire Alternativa",
                                    "label-mode": "floating",
                                    value: _ctx.linieNoua.Nume,
                                    onValueChanged: _cache[93] || (_cache[93] = (e) => _ctx.linieNoua.Nume = e.value)
                                  }, null, 8, ["value"])
                                ])
                              ]))
                            : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_147, [
            _createElementVNode("div", _hoisted_148, [
              _createVNode(_component_DxButton, {
                text: "Salvează",
                type: "success",
                width: "120",
                height: "32",
                "styling-mode": "outlined",
                onClick: _ctx.onSaveAdd
              }, null, 8, ["onClick"]),
              _createVNode(_component_DxButton, {
                text: "Închide",
                type: "danger",
                width: "120",
                height: "32",
                "styling-mode": "outlined",
                onClick: _ctx.onCloseAdd
              }, null, 8, ["onClick"])
            ])
          ])
        ])
      ]),
      _: 1
    }, 8, ["visible", "width", "height", "onHiding"]),
    (_ctx.document && !_ctx.sidebarOpen)
      ? (_openBlock(), _createElementBlock("button", {
          key: 3,
          class: "fab-edit-document",
          title: "Editează document",
          onClick: _cache[95] || (_cache[95] = ($event: any) => (_ctx.$emit('open-edit-document')))
        }, [...(_cache[119] || (_cache[119] = [
          _createElementVNode("i", { class: "dx-icon-edit" }, null, -1)
        ]))]))
      : _createCommentVNode("", true)
  ]))
}